<template>
    <section class="appointment-calendar">
        <header class="appointment-calendar__weekdays">
            <h5 v-for="(weekday, index) in weekDays" :key="index" class="appointment-calendar__weekday">
                {{ weekday }}
            </h5>
        </header>

        <ol class="appointment-calendar__days">
            <li v-for="(day, index) in monthDays" :key="index" class="appointment-calendar__day">
                <external-calendar-day
                    v-if="day"
                    ref="externalCalendarDay"
                    :year="year"
                    :month="month"
                    :day="day"
                    :slotsCount="getSlotsCountForDay(day)"
                    :physician="physician"
                    :practice="practice"
                    :selectedSlotsByDate="selectedSlotsByDate"
                    @emitEvent="emitEvent($event)"
                ></external-calendar-day>
            </li>
        </ol>
    </section>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarMixin from 'mixins/CalendarMixin'
    import ExternalCalendarDay from 'components/page-elements/referrals-new-schedule/ExternalCalendarDay'

    export default {
        mixins: [CalendarMixin],

        components: {
            ExternalCalendarDay,
        },

        props: {
            dates: { type: Object, required: true },
            physician: { type: Object, required: true },
            practice: { type: Object, required: true },
            selectedSlotsByDate: { type: Object, required: false, default: undefined },
        },

        methods: {
            getSlotsCountForDay(day) {
                return (
                    (this.dates[dayjs().year(this.year).month(this.month).date(day).startOf('day').format()] || {}).slotCount || 0
                )
            },
        },
    }
</script>
